import { render, staticRenderFns } from "./TableViewTruckList.vue?vue&type=template&id=0b127f04&scoped=true"
import script from "./TableViewTruckList.vue?vue&type=script&lang=js"
export * from "./TableViewTruckList.vue?vue&type=script&lang=js"
import style0 from "./TableViewTruckList.vue?vue&type=style&index=0&id=0b127f04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b127f04",
  null
  
)

export default component.exports